import { rootApi } from "../rootApi";
import { getEnv } from "../../config/runtimeConfig";

const PARAM_MAP = {
  startDate: "StartDate",
  endDate: "EndDate",
  searchText: "SearchText",
  customerName: "CustomerName",
  kalemTanimi: "KalemTanimi",
  siparisiOlusturanBayi: "SiparisiOlusturanBayi",
  siparisNoRef: "SiparisNoRef",
  irsaliyeTarihi: "IrsaliyeTarihi",
  languageId: "LanguageId",
  sortBy: "SortBy",
  sortDirection: "SortDirection",
};

const appendFilters = (p, filters) => {
  (filters || [])
    .filter((f) => f && f.column != null && f.operator != null && f.value != null)
    .forEach((f, i) => {
      p.set(`Filters[${i}].Column`, f.column);
      p.set(`Filters[${i}].Operator`, f.operator);
      p.set(`Filters[${i}].Value`, f.value);
    });
};


const buildParams = (args = {}) => {
  const p = new URLSearchParams();

  Object.entries(PARAM_MAP).forEach(([key, param]) => {
    const value = args[key];
    if (value !== null && value !== undefined && value !== "") {
      p.set(param, value);
    }
  });

  appendFilters(p, args.filters);
  return p;
};

export const shipmentDeliveryApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // LIST
    getShipmentDeliveryList: builder.query({
      query: (args = {}) => {
        const p = buildParams(args);
        p.set("PageNumber", args.pageNumber ?? 1);
        p.set("PageSize", args.pageSize ?? 10);
        return { url: `v1/ShipmentDelivery/list?${p.toString()}`, method: "GET" };
      },
      transformResponse: (resp) => {
        const paged = resp?.data ?? resp;
        return {
          rows: paged?.rows ?? [],
          totalCount: paged?.totalCount ?? 0,
        };
      },
      providesTags: () => [{ type: "ShipmentDelivery", id: "LIST" }],
    }),

    exportShipmentDeliveryToExcel: builder.query({
      queryFn: async (args = {}) => {
        try {
          const p = buildParams(args);

          const apiBaseUrl = getEnv("REACT_APP_API_URL") || "";
          const baseUrl = apiBaseUrl.replace(/\/+$/, "");
          const url = `${baseUrl}/v1/ShipmentDelivery/export?${p.toString()}`;

          const response = await fetch(url, {
            method: "GET",
            credentials: "include", 
            headers: {
              "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const blob = await response.blob();

          return { data: blob };
        } catch (error) {
          console.error("Export error:", error);
          return { error: { status: 'FETCH_ERROR', error: error.message } };
        }
      },
    }),
  }),
});

export const { 
  useGetShipmentDeliveryListQuery, 
  useLazyExportShipmentDeliveryToExcelQuery 
} = shipmentDeliveryApi;

